export default "__VITE_ASSET__e53b9307__"